import { CHANGE_ROUTE } from "../constants/ActionTypes";

var initialRoute = "/";

export default function(state = initialRoute, action) {
	// console.log(state, action);
	switch (action.type) {
	case CHANGE_ROUTE:
		return action.route;
	default:
		return state;
	}
}



/** WEBPACK FOOTER **
 ** ./src/scripts/reducers/route.js
 **/